export const coopType =  [
    {
      name: "推广人",
      value: 'o_promoter',
    },
    {
      name: "运营主理人",
      value: 'o_manager',
    },
    {
      name: "运营合伙人",
      value: 'o_owner',
    }
  ]